import { apiPrivacy } from "../app/variables";

export default function ({ error: nuxtError }, inject) {
  const baseURL = apiPrivacy || 'https://tione.api-used.ru/api';

  /**
   * Простая обертка над fetch
   * @param {string} path - Путь к ресурсу (например, '/api/website/privacy')
   * @param {object} options - Опции для fetch (method, headers, body, etc.)
   * @returns {Promise<any>} - Данные ответа или проброшенная ошибка
   */
  const simpleFetch = async (path, options = {}) => {
    const defaultHeaders = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    };

    const requestOptions = {
      ...options,
      headers: {
        ...defaultHeaders,
        ...options.headers,
      },
    };

    if (requestOptions.body && typeof requestOptions.body === 'object' && requestOptions.headers['Content-Type'] === 'application/json') {
      requestOptions.body = JSON.stringify(requestOptions.body);
    }

    try {
      // Собираем полный URL
      const fullUrl = `${baseURL}${path}`;

      const response = await fetch(fullUrl, requestOptions);

      if (!response.ok) {
        let errorData;
        try {
          errorData = await response.json();
        } catch (e) {
          errorData = { message: response.statusText || `HTTP error ${response.status}` };
        }
        const error = new Error(errorData.message || `HTTP error! Status: ${response.status}`);
        error.response = response;
        error.status = response.status;
        error.data = errorData;
        throw error;
      }

      if (response.status === 204 || response.headers.get('content-length') === '0') {
        return null;
      }

      const contentType = response.headers.get('content-type');
      if (contentType && contentType.includes('application/json')) {
        return response.json();
      }
      return response.text();
    } catch (error) {
      throw error;
    }
  };

  // API методы
  const api = {
    /**
     * Получает политику конфиденциальности.
     * @param {object} policyParams - Параметры для запроса политики
     * @param {string} policyParams.host - Домен
     * @param {string} policyParams.legal_name - Юр. лицо
     * @param {string} policyParams.legal_ogrn - ОГРН
     * @param {string} policyParams.legal_inn - ИНН
     * @param {string} policyParams.legal_kpp - КПП
     * @param {string} policyParams.legal_address - Юр. адрес.
     * @returns {Promise<{heading: string, text: string}>} - Объект с заголовком и текстом политики.
     */
    getPrivacyPolicy: (policyParams) => {
      return simpleFetch('/website/privacy', {
        method: 'POST',
        body: policyParams,
      });
    },

    getCatalogAll: () => {
      return simpleFetch('/rate-car/getTree', {
        method: 'GET'
      })
    }

    // get: (path, options = {}) => simpleFetch(path, { ...options, method: 'GET' }),
    // post: (path, body, options = {}) => simpleFetch(path, { ...options, method: 'POST', body }),
    // put: (path, body, options = {}) => simpleFetch(path, { ...options, method: 'PUT', body }),
    // delete: (path, options = {}) => simpleFetch(path, { ...options, method: 'DELETE' }),
  };

  inject('apiService', api);
}
